import PropTypes from 'prop-types'
import React, { Component } from 'react'

import CSSModules from 'react-css-modules'
import styles from './landing_header.scss'

class LandingHeader extends Component {

	render() {
		return (
			<header>
				{this.props.children}
			</header>
		)
	}

}

LandingHeader.propTypes = {
	children: PropTypes.node,
}

export default CSSModules(LandingHeader, styles, {allowMultiple: true})
